import { render, staticRenderFns } from "./PublicationConfirm.vue?vue&type=template&id=048aa9e6&scoped=true"
import script from "./PublicationConfirm.vue?vue&type=script&lang=ts"
export * from "./PublicationConfirm.vue?vue&type=script&lang=ts"
import style0 from "./PublicationConfirm.vue?vue&type=style&index=0&id=048aa9e6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048aa9e6",
  null
  
)

export default component.exports